import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getIsLoading = (state) => get(state, 'dashboard.loading', false);
export const getLoaded = (state) => get(state, 'dashboard.loaded', false);

export const getTotalByAccount = (state) => get(state, 'dashboard.result.totalByAccount', []);
export const getTotalByCostCenter = (state) => get(state, 'dashboard.result.totalByCostCenter', []);
export const getTotalByStatus = (state) => get(state, 'dashboard.result.totalByStatus', []);
export const getAmountByCostCenter = (state) => get(state, 'dashboard.result.amountByCostCenter', []);

export const getAssetsSummary = (state) =>
  get(state, 'dashboard.data.assetsSummary',
    get(state, 'dashboard.result.assetsSummary', {})
  );

export const getAccountTotals = (state) => get(state, 'dashboard.entities.accountTotal', {});
export const getCostCenterTotals = (state) => get(state, 'dashboard.entities.costCenterTotal', {});
export const getCostCenterTotalAmounts = (state) => get(state, 'dashboard.entities.costCenterTotalAmount', {});
export const getStatusTotals = (state) => get(state, 'dashboard.entities.statusTotal', {});

export const getAllTotalByAccount = createSelector(
  [getTotalByAccount, getAccountTotals],
  (ids, accounts) => ids.map((id) => accounts[id])
);
export const getAllTotalByCostCenter = createSelector(
  [getTotalByCostCenter, getCostCenterTotals],
  (ids, costCenters) => ids.map((id) => costCenters[id])
);
export const getAllTotalByStatus = createSelector(
  [getTotalByStatus, getStatusTotals],
  (ids, status) => ids.map((id) => status[id])
);
export const getAllAmountByCostCenter = createSelector(
  [getAmountByCostCenter, getCostCenterTotalAmounts],
  (ids, costCenters) => ids.map((id) => costCenters[id])
);



// WEBPACK FOOTER //
// src/selectors/dashboard.js